import { useState } from "react";

export default function useObjectState(init) {
  const [state, _setState] = useState(init);
  const setState = (props) =>
    _setState((prev) => {
      return { ...prev, ...props };
    });
  const clearState = () => _setState({});
  return [state, setState, clearState];
}
